import CancellationQuestionnaireService from 'src/modules/userQuestionnaire/cancellationQuestionnaireService';
import selectors from 'src/modules/userQuestionnaire/cancellationQuestionnaireSelectors';
import Errors from 'src/modules/shared/error/errors';

const prefix = 'CANCELLATION_QUESTIONNAIRE';

const cancellationQuestionnaireActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  RESETED: `${prefix}_RESETED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  doReset: () => async (dispatch) => {
    dispatch({
      type: cancellationQuestionnaireActions.RESETED,
    });

    dispatch(cancellationQuestionnaireActions.doFetch());
  },

  doChangePagination:
    (pagination) => async (dispatch, getState) => {
      dispatch({
        type: cancellationQuestionnaireActions.PAGINATION_CHANGED,
        payload: pagination,
      });

      const filter = selectors.selectFilter(getState());
      const rawFilter = selectors.selectRawFilter(
        getState(),
      );
      dispatch(
        cancellationQuestionnaireActions.doFetch(
          filter,
          rawFilter,
          true,
        ),
      );
    },

  doChangeSort: (sorter) => async (dispatch, getState) => {
    dispatch({
      type: cancellationQuestionnaireActions.SORTER_CHANGED,
      payload: sorter,
    });

    const filter = selectors.selectFilter(getState());
    const rawFilter = selectors.selectRawFilter(getState());
    dispatch(
      cancellationQuestionnaireActions.doFetch(
        filter,
        rawFilter,
        true,
      ),
    );
  },

  doFetch:
    (filter?, rawFilter?, keepPagination = false) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: cancellationQuestionnaireActions.FETCH_STARTED,
          payload: { filter, rawFilter, keepPagination },
        });

        const response =
          await CancellationQuestionnaireService.fetch(
            filter,
            selectors.selectOrderBy(getState()),
            selectors.selectLimit(getState()),
            selectors.selectOffset(getState()),
          );

        dispatch({
          type: cancellationQuestionnaireActions.FETCH_SUCCESS,
          payload: {
            rows: response.rows,
            count: response.count,
          },
        });
      } catch (error) {
        Errors.handle(error);

        dispatch({
          type: cancellationQuestionnaireActions.FETCH_ERROR,
        });
      }
    },
};

export default cancellationQuestionnaireActions;
